import { loadJS } from 'hobbit-base/modules/utils';

export default function useAppier(key) {
  const appId = key ?? window.$hobbit.$theme?.appierAppId ?? '';
  if (!appId || window.qg) return;
  const js = window.qg = function () {
    js.callmethod ? js.callmethod.call(js, arguments) : js.queue.push(arguments);
  };
  js.queue = [];
  loadJS(`https://cdn.qgr.ph/qgraph.${appId}.js`, 1e4, false).catch(error => {
    console.warn('Load Appier\'s SDK Failed', error);
  });
}
